import { createFileRoute } from "@tanstack/react-router";
import { authorizationServerMetadataRoute } from "@/app-clients/viewer-identity-flow";

export const Route = createFileRoute(
    "/.well-known/oauth-authorization-server/api/auth",
)({
    ...authorizationServerMetadataRoute,
});
